import {Outlet,createRootRoute,createRoute,createRouter} from '@tanstack/react-router';
import type {InterfaceModel,SurfaceIdentity} from './model';
import {routesFor} from './model';
import {Application} from './application';

export function createApplicationRouter(model:InterfaceModel,surface:SurfaceIdentity,authSource:string){
  const rootRoute=createRootRoute({component:Outlet,notFoundComponent:()=> <main className="protected-gate" role="alert"><p className="eyebrow">Route unavailable</p><h1>That view is not in this application.</h1></main>});
  const children=routesFor(model,surface).map(route=>createRoute({
    getParentRoute:()=>rootRoute,
    path:route.path,
    component:()=> <Application model={model} surface={surface} route={route} authSource={authSource}/>
  }));
  if(children.length===0) throw new Error(`Surface ${surface} has no projected routes.`);
  return createRouter({routeTree:rootRoute.addChildren(children),defaultPreload:'intent',scrollRestoration:true});
}
